// extracted by mini-css-extract-plugin
module.exports = {"onScreen":"style_onScreen__qBYL_","appearAndMoveDown":"style_appearAndMoveDown__2ue33","moveDownAndAcross":"style_moveDownAndAcross__1l1uI"};